import React from 'react';
import { Button } from 'antd';

interface MobileBottomNavItem {
  key: string;
  label: string;
  icon: React.ReactNode;
}

interface MobileBottomNavProps {
  items: MobileBottomNavItem[];
  activeKey: string;
  onChange: (key: string) => void;
  hidden?: boolean;
}

const MOBILE_BOTTOM_NAV_STYLES = `
  .mobile-bottom-nav {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 115;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 2px;
    padding: 8px 12px calc(env(safe-area-inset-bottom) + 8px);
    background: rgba(255,255,255,0.96);
    backdrop-filter: blur(16px);
    border-top: 1px solid rgba(231, 237, 244, 0.95);
    transition: transform 0.24s ease, opacity 0.24s ease;
  }

  .mobile-bottom-nav--hidden {
    transform: translateY(120%);
    opacity: 0;
    pointer-events: none;
  }

  .mobile-bottom-nav__item.ant-btn {
    height: 64px;
    border: none;
    border-radius: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    color: #7A869A;
    background: transparent;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
  }

  .mobile-bottom-nav__item.ant-btn .mobile-bottom-nav__icon {
    font-size: 21px;
    line-height: 1;
  }

  .mobile-bottom-nav__item--active.ant-btn {
    color: #1677FF;
    background: rgba(22, 119, 255, 0.08);
  }
`;

const MobileBottomNav: React.FC<MobileBottomNavProps> = ({
  items,
  activeKey,
  onChange,
  hidden = false,
}) => (
  <>
    <style>{MOBILE_BOTTOM_NAV_STYLES}</style>
    <nav className={`mobile-bottom-nav ${hidden ? 'mobile-bottom-nav--hidden' : ''}`}>
      {items.map((item) => {
        const active = item.key === activeKey;
        return (
          <Button
            key={item.key}
            type="text"
            className={`mobile-bottom-nav__item ${active ? 'mobile-bottom-nav__item--active' : ''}`}
            onClick={() => onChange(item.key)}
          >
            <span className="mobile-bottom-nav__icon">{item.icon}</span>
            <span>{item.label}</span>
          </Button>
        );
      })}
    </nav>
  </>
);

export default MobileBottomNav;
